import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { WorkOrderState } from 'app/_models/work-order-state';

type ProgressStep = {
  number: number;
  name: string;
  inlineStyle?: string;
};

const BASE_STEPS: ProgressStep[] = [
  {
    number: 1,
    name: WorkOrderState.Pending,
  }, {
    number: 2,
    name: WorkOrderState.Approved,
  }, {
    number: 3,
    name: 'Released', // WorkOrderState.Available
  }
];

const TOC_STEPS: ProgressStep[] = [
  {
    number: 1,
    name: 'Transfer<br>Requested',
  }, {
    number: 2,
    name: 'Work<br>In Progress'
  }, {
    number: 3,
    name: 'Transfer<br>Return Requested'
  }, {
    number: 4,
    name: 'Control<br>Returned',
  }
];

@Component({
  selector: 'step-progress-bar',
  templateUrl: './step-progress-bar.component.html'
})
export class StepProgressBarComponent implements OnChanges {
  @Input() activeStep: number;
  @Input() scheduledStartTime?: any;
  @Input() transferOfControl?: boolean;
  @Input() workOrderState?: WorkOrderState;

  public steps: ProgressStep[] = [];
  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.activeStep || changes.scheduledStartTime || changes.transferOfControl || changes.workOrderState) {
      this.configureStepper();
    }
  }

  private configureStepper(): void {
    this.steps = this.getSteps();
  }

  private getSteps(): ProgressStep[] {
    let steps: ProgressStep[] = BASE_STEPS.map((step) => ({ ...step }));

    if (this.scheduledStartTime) {
      steps.push({
        number: 4,
        name: 'Scheduled',
      });
    }

    if (this.transferOfControl) {
      steps = TOC_STEPS.map((step) => ({ ...step }));

      const activeStep = steps.find((step) => step.number === this.activeStep);
      if (activeStep) {
        activeStep.inlineStyle = `--step-active-colour: ${this.getTocActiveColor()};`;
      }
    }

    return steps;
  }

  private getTocActiveColor(): string {
    return this.workOrderState === WorkOrderState.PendingXfer || this.workOrderState === WorkOrderState.PendingReturn
      ? 'var(--skylark-rag-red)'
      : 'var(--skylark-rag-amber)';
  }

  isCompleted() {
    return this.activeStep === this.steps.length;
  }

  detectStepClass(step: number) {
    let classStr = '';

    if (step === this.activeStep) {
      classStr = 'active';

      if (this.isCompleted()) {
        classStr = classStr + ' completed';
      }
    } else if (step < this.activeStep) {
      classStr = 'completed';
    }

    return classStr;
  }

}
